import { makeStyles } from "@material-ui/core/styles";
import { Colors, DRAWER_MAX, DRAWER_MIN } from "constants/constants";

export const useTopHeadStyles = makeStyles((theme) => ({
  accSmallBox: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  accName: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
  },
  username: {
    color: Colors.WHITE,
    fontWeight: 500,
  },
  role: {
    color: Colors.WHITE,
  },
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    color: theme.palette.primary.main,
    background: Colors.WHITE,
  },
  avatarIcon: {
    fontSize: 30,
  },
  menuButton: {
    color: Colors.WHITE,
    display: "none"
  },
  "@media (max-width: 1280px)": {
    accName: {
      display: "none",
    },
    menuButton: {
      display: "block"
    },
  },
  "@media (max-width: 840px)": {
    accName: {
      display: "none",
    },
  },
}));

export const useAppBarStyles = makeStyles((theme) => ({
  appBar: {
    position: "fixed",
    background: theme.palette.primary.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  toolBar: {
    minHeight: 68,
  },
  contentContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  logoContainer: {
    display: "flex",
    gap: theme.spacing(2),
  },
  contentEndContainer: {
    display: "flex",
    gap: 16,
  },
}));

export const useDrawerMenuStyles = makeStyles((theme) => ({
  body: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginTop: DRAWER_MIN,
  },
  customMaxWidth: {
    width: DRAWER_MAX,
  },
  customMinWidth: {
    width: DRAWER_MIN,
  },
  disableMinWidth: {
    width: 0,
  },
  drawerContainer: {
    display: "block",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: theme.palette.primary.main,
  },
  drawer: {
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logoContainer: {
    height: 68,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  menuLink: {
    color: Colors.WHITE,
    borderRadius: 0,
    width: "100%",
    height: DRAWER_MIN,
    display: "flex",
    justifyContent: "flex-start",
    "&.MuiButton-contained": {
      padding: 16,
    },
  },
  collapseMenuLink: {
    color: Colors.WHITE,
    borderRadius: 0,
    width: "100%",
    height: DRAWER_MIN,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&.MuiButton-contained": {
      padding: 16,
    },
  },
  collapseMenuBox: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  activeMenuLink: {
    background: "#164578",
    "&.MuiButton-contained:hover": {
      background: "#164578",
    },
  },
  buttonDrawerWidth: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  content: {
    overflow: "auto",
    background: theme.palette.background.default,
    boxSizing: "border-box",
    height: "calc(100vh - 64px)",
    width: "100%",

    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.background.default,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.light,
      borderRadius: "5px",
    },
  },
  expandCollapseMenu: {
    color: Colors.WHITE,
    borderRadius: 0,
    background: theme.palette.primary.main,
  },
}));

export const useCollapseSubMenuStyles = makeStyles((theme) => ({
  collapse: {
    width: "100%",
  },
  subMenuLink: {
    borderRadius: 0,
    width: "100%",
    height: 64,
    display: "flex",
    justifyContent: "flex-start",
    background: "#061729",
    padding: theme.spacing(3, 3, 3, 4),
    color: Colors.WHITE,
  },
  activeSubMenuLink: {
    background: "#194f88",
    "&.MuiButton-contained:hover": {
      background: "#194f88",
    },
  },
}));
